import { Link } from 'react-router-dom';
import './index.css';
import heroCard1 from '../../../assets/images/home-figma/hero-card-1.png';
import heroCard2 from '../../../assets/images/home-figma/hero-card-2.png';
import heroCard3 from '../../../assets/images/home-figma/hero-card-3.png';
import heroCard4 from '../../../assets/images/home-figma/hero-card-4.png';
import heroCard5 from '../../../assets/images/home-figma/hero-card-5.png';
import getStarted1 from '../../../assets/images/home-figma/get-started-1.png';
import getStarted2 from '../../../assets/images/home-figma/get-started-2.png';
import getStarted3 from '../../../assets/images/home-figma/get-started-3.png';
import communicationMain from '../../../assets/images/home-figma/comms-main.png';
import dating1 from '../../../assets/images/home-figma/dating-1.png';
import dating2 from '../../../assets/images/home-figma/dating-2.png';
import dating3 from '../../../assets/images/home-figma/dating-3.png';
import matchesBackground from '../../../assets/images/home-figma/matches-bg.png';
import tiktok1 from '../../../assets/images/home-figma/tiktok-1.png';
import tiktok2 from '../../../assets/images/home-figma/tiktok-2.png';
import tiktok3 from '../../../assets/images/home-figma/tiktok-3.png';
import tiktok4 from '../../../assets/images/home-figma/tiktok-4.png';
import tiktok5 from '../../../assets/images/home-figma/tiktok-5.png';

const heroCards = [heroCard1, heroCard2, heroCard3, heroCard4, heroCard5];
const matchCards = [getStarted1, getStarted2, getStarted3];
const datingCards = [dating1, dating2, dating3];
const tiktokCards = [tiktok1, tiktok2, tiktok3, tiktok4, tiktok5];

const Home = () => {
  return (
    <main className="figma-home">
      <section className="figma-hero appContainer">
        <div className="figma-hero__gallery">
          {heroCards.map((card, index) => (
            <div key={card} className={`figma-photo figma-photo--hero-${index + 1}`}>
              <img src={card} alt="Profile preview" />
            </div>
          ))}
          <span className="figma-hero__heart figma-hero__heart--a" />
          <span className="figma-hero__heart figma-hero__heart--b" />
          <span className="figma-hero__heart figma-hero__heart--c" />
        </div>
        <div className="figma-hero__headline">
          <p className="figma-script figma-script--top">Your</p>
          <h1 className="figma-hero__title">
            <span>Love</span> <span>Story</span>
          </h1>
          <p className="figma-script figma-script--bottom">Starts Now</p>
          <p className="figma-hero__subtitle">
            Find your perfect match and start a new
            <br />
            chapter in your love story
          </p>
        </div>
      </section>

      <section className="figma-section appContainer">
        <div className="figma-copy figma-copy--intention">
          <span className="figma-intention-badge">
            <span className="figma-intention-badge__dot" aria-hidden="true" />
            Dating with more intention
          </span>
          <h2>
            <span className="figma-copy__title-dark">Stop Swiping Randomly.</span>{' '}
            <span className="figma-copy__title-accent">Meet People Who Actually Fit.</span>
          </h2>
          <p>
            Choose what matters to you, from lifestyle and interests to values and relationship preferences, and discover people who better match what you&apos;re looking for.
          </p>
        </div>
        <div className="figma-stack">
          {matchCards.map((card, index) => (
            <article key={card} className={`figma-card figma-card--stack-${index + 1}`}>
              <img src={card} alt="Dating profile card" />
              <p>Find Your Love</p>
            </article>
          ))}
        </div>
      </section>

      <section className="figma-comms appContainer">
        <div className="figma-comms__image">
          <img src={communicationMain} alt="Couple spending time together" />
        </div>
        <div className="figma-comms__content">
          <h2>
            Discover exciting date ideas, meaningful connections, and unforgettable experiences — all in one place. We have everything you need to curate the best dating experience right here.
          </h2>
          <p className="figma-comms__supporting">
            Start Planning Your Next Great Connection Today
          </p>
          <ul className="figma-comms__list">
            <li>
              Discover exciting date ideas such as going on a virtual date right here on the site with our Watch Together feature.
            </li>
            <li>
              Find out what you have in common with your matches by playing our This or That compatibility game right here on the site.
            </li>
            <li>
              Break the ice and invite your match to play our Tic Tac Toe or Emoji play game with you.
            </li>
            <li>
              Let someone know you&apos;re thinking about them by sending a greeting card or one of the gifts offered in the Gift Store.
            </li>
          </ul>
        </div>
      </section>

      <section className="figma-section appContainer figma-section--dating">
        <div className="figma-copy figma-copy--dating">
          <h2>More Than Just Dating.</h2>
          <p>
            Connect with people who share your interests, values, and goals. We believe every great relationship starts with authenticity, trust, and real communication.
          </p>
        </div>
        <div className="figma-dating-gallery">
          {datingCards.map((card, index) => (
            <div key={card} className={`figma-photo figma-photo--dating-${index + 1}`}>
              <img src={card} alt="Dating profile preview" />
            </div>
          ))}
        </div>
      </section>

      <section className="figma-matches">
        <div className="figma-matches__bg">
          <img src={matchesBackground} alt="People using Danty app" />
        </div>
        <div className="figma-matches__overlay appContainer">
          <h2>More Than Matches. Meaningful Connections.</h2>
          <Link to="/signup" className="figma-cta figma-cta--blue">
            Join Now
          </Link>
        </div>
      </section>

      <section className="figma-tiktok appContainer">
        <h2>
          Discover the fun and excitement of crafting memorable moments together. Create the perfect date experience tailored to your vibe.
        </h2>
        <div className="figma-tiktok__grid">
          {tiktokCards.map((card) => (
            <div key={card} className="figma-tiktok__item">
              <img src={card} alt="TikTok post preview" />
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Home;
